import { Theme } from '@mui/material';
import { defaultCheckboxProps } from '../../components';

export const tableStyles = {
  muiTablePaperProps: {
    sx: (theme: Theme) => ({
      boxShadow: 'none',
      '& .MuiFormLabel-root': {
        marginBottom: 0,
        fontWeight: 'normal',
        color: 'inherit',
        font: 'inherit',
        textTransform: 'none',
      },
      '& .MuiTableContainer-root': {
        maxHeight: 'calc(100vh - 200px)',
      },
      '& .MuiFormControl-root': {
        margin: '4px 0 0',
      },
      '& tr .MuiTableCell-root:has(.MuiFormControl-root)': {
        verticalAlign: 'baseline',
      },
      '& .Mui-selected td': {
        background: theme.palette.primary[20],
        '::after': {
          background: 'none',
        },
      },
    }),
  },
  muiTableBodyCellProps: {
    sx: (theme: Theme) => ({
      border: 'none',
      background: theme.palette.common.white,
      fontSize: '12px',
      padding: '8px',
      height: '52px',
      minHeight: '52px',
      maxHeight: '52px',
      verticalAlign: 'center',
    }),
  },
  muiTableProps: {
    sx: {
      borderCollapse: 'separate',
      borderSpacing: '0 4px',
    },
  },
  muiTableHeadRowProps: {
    sx: {
      boxShadow: 'none',
    },
  },
  muiTableHeadCellProps: {
    sx: {
      border: 'none',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '21px',
      fontStyle: 'normal',
      textTransform: 'captialize',
    },
  },
  muiBottomToolbarProps: {
    sx: {
      boxShadow: 'none',
      '& .MuiTablePagination-root': {
        width: '100%',
        '& .MuiInputBase-root': {
          borderRadius: '4px',
        },
      },
      '& > .MuiBox-root > .MuiBox-root': {
        width: '100%',
      },
    },
  },
  muiPaginationProps: {
    showFirstButton: true,
    showLastButton: true,
    variant: 'outlined' as const,
    shape: 'rounded' as const,
    sx: {
      '& .MuiFormLabel-root': {
        marginBottom: '0',
      },
    },
  },
  muiSelectCheckboxProps: { ...defaultCheckboxProps(), sx: { marginLeft: '-2px' } },
  muiSelectAllCheckboxProps: defaultCheckboxProps(),
};

export const tableModalStyles = {
  '& .MuiPaper-root': {
    boxShadow: 'none',
  },
  '& .MuiPaper-root > .MuiBox-root': {
    display: 'none',
  },
};

export const muiTableBodyRowStyles = (isCreating: boolean) => () => ({
  borderRadius: '4px',
  cursor: 'pointer',
  'button[aria-label=Expand]': isCreating
    ? {
        display: 'none',
      }
    : null,
  '& td:first-of-type': {
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
  },
  '& td:last-of-type': {
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
  },
});
